<mat-card class="cardT lembretes-titulo">
  <span>Lembretes</span>
  <span class="lembretes-acoes">
    <button
      mat-icon-button
      type="button"
      matTooltip="Calendário"
      [class.lembretes-acao--ativa]="exibindoCalendario"
      [disabled]="exibindoCalendario"
      (click)="abrirCalendario()">
      <mat-icon>calendar_today</mat-icon>
    </button>

    <button
      mat-icon-button
      type="button"
      matTooltip="Lista"
      [class.lembretes-acao--ativa]="!exibindoCalendario"
      [disabled]="!exibindoCalendario"
      (click)="voltarParaLista()">
      <mat-icon>list_alt</mat-icon>
    </button>
  </span>
</mat-card>

<div class="destino" *ngIf="celularCarregado && !celularMascarado">
  <mat-icon>warning_amber</mat-icon>
  <span>Cadastre um número de celular no seu perfil para receber os lembretes.</span>
</div>

<app-lista-dados
  *ngIf="!exibindoCalendario"
  [upTitulo]="'Lista de Lembretes'"
  [upIcone]="'notifications_active'"
  [upCor]="'1565C0'"
  [upDados]="lembretes"
  [upColunas]="colunasListaDados"
  [upCarregando]="!!subscription"
  [upHabilitaEditarLinha]="true"
  [upLargura]="2"
  [upHabilitaContador]="true"
  [upHabilitaFiltroRapido]="false"
  [upClasseLinha]="classeLinha"
  [upAcoesLinha]="acoesLinha"
  [upVisivelBotaoEditar]="podeAlterar"
  [upVisivelBotaoExcluir]="podeExcluir"
  [upTextoBotaoExcluir]="'Excluir'"
  [upIconeBotaoExcluir]="'delete'"
  (ueIniciarEdicaoLinha)="onIniciarEdicao($event)"
  (ueSalvarLinha)="onSalvarLinha($event)"
  (ueAcaoLinha)="executarAcaoLinha($event)"
  (ueBotaoExcluir)="onExcluir($event)">
</app-lista-dados>

<app-lembretes-calendario *ngIf="exibindoCalendario && dadosCalendario" [data]="dadosCalendario"></app-lembretes-calendario>
